import React, { createContext, useContext, useState } from 'react';

const ScrollContext = createContext();

export const useScrollContext = () => {
  const context = useContext(ScrollContext);
  if (!context) {
    throw new Error('useScrollContext must be used within a ScrollProvider');
  }
  return context;
};

export const ScrollProvider = ({ children }) => {
  const [isHomePage, setIsHomePage] = useState(false);

  const handleScrollToTop = () => {
    // Simple scroll to top for all pages
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <ScrollContext.Provider value={{
      isHomePage,
      setIsHomePage,
      handleScrollToTop
    }}>
      {children}
    </ScrollContext.Provider>
  );
};
